import { gql } from '@apollo/client';

export default gql`
  query accountCreditCardsCheck {
    accountCreditCardsCheck {
      hasCards
      defaultCardExpired
      defaultCardExpiring
    }
  }
`;
